// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__2aY0D","Div":"CustomFadeBox_Div__2VLLc","LargeDiv":"CustomFadeBox_LargeDiv__Yzxpq"};